import { computed } from 'mobx';
import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class ClientListDataService extends DataService<typeof Model.Crm.Logic.ViewModels.ClientSummary, Model.Crm.Logic.ViewModels.ClientSummary, ClientSummary> {
    protected map(entity: Model.Crm.Logic.ViewModels.ClientSummary): ClientSummary {
        return new ClientSummaryModel(entity);
    }

    public static make(ctx?: any): ClientListDataService {
        return new ClientListDataService(ctx, ctx => ctx.ClientsSummaries);
    }
}

export class ClientSummaryModel extends EntityModel<Model.Crm.Logic.ViewModels.ClientSummary, ClientSummary> implements ClientSummary {
    @property<ClientSummaryModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<ClientSummaryModel>(o => o.entity.clientNumber, (o, value) => o.entity.clientNumber = value)
    public clientNumber: string;

    @property<ClientSummaryModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
    public displayName: string;

    @property<ClientSummaryModel>(o => o.entity.priority, (o, value) => o.entity.priority = value)
    public priority: Model.Crm.Domain.Models.ClientPriority;

	@computed
	public get priorityText(): string {
        switch (this.entity.priority) {
            case 0:
                return 'Low';
            case 1:
                return 'Medium';
            case 2:
                return 'Normal';
            case 3:
                return 'High';
            case 4:
                return 'Super';
            case 5:
                return 'Vip';
        }
        return null;
    }

    @property<ClientSummaryModel>(o => o.entity.type, (o, value) => o.entity.type = value)
    public type: Model.Crm.Domain.Models.ClientType;

	@computed
	public get typeText(): string {
        switch (this.entity.type) {
            case 0:
                return 'Person';
            case 1:
                return 'Company';
            case 2:
                return 'Group';
        }
        return null;
    }

    @property<ClientSummaryModel>(o => o.entity.loginUserName, (o, value) => o.entity.loginUserName = value)
    public loginUserName: string;

    @property<ClientSummaryModel>(o => o.entity.status, (o, value) => o.entity.status = value)
    public status: Model.Crm.Domain.Models.ClientStatus;

	@computed
	public get statusText(): string {
        switch (this.entity.status) {
            case 0:
                return 'Client';
            case 1:
                return 'Will book';
            case 2:
                return 'Interested';
            case 3:
                return 'Only information request';
            case 4:
                return 'Not interested';
            case 5:
                return 'No more contact';
            case 6:
                return 'Co-traveler';
        }
        return null;
    }

    @property<ClientSummaryModel>(o => o.entity.managedByUserName, (o, value) => o.entity.managedByUserName = value)
    public managedByUserName: string;

    @property<ClientSummaryModel>(o => o.entity.managedById, (o, value) => o.entity.managedById = value)
    public managedById: number;
}



// WEBPACK FOOTER //
// ./src/app/crm/clients/list/client-list.data.ts